/**
 * Sticky mobile Add to Cart bar — product pages only.
 * Self-contained: rather than reimplementing variant selection / AJAX
 * behavior, this mirrors the real page's Add to Cart button and, on click,
 * simply clicks that real button. That means it automatically inherits
 * whatever the real button already does (correct variant, correct price,
 * the existing AJAX cart popup) with zero duplicated logic.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-add-to-cart]');
    if (!bar) return;

    var formClass = bar.getAttribute('data-target-form-class');
    var form = formClass ? document.querySelector('form.' + formClass.split(' ')[0]) : null;
    if (!form) return;

    var realBtn = form.querySelector('[data-add-to-cart]');
    if (!realBtn) return;

    var realPriceWrapper = document.querySelector('.product__price [data-price]');

    var stickyBtn = bar.querySelector('[data-sticky-add-to-cart-btn]');
    var stickyBtnText = bar.querySelector('[data-sticky-add-to-cart-btn-text]');
    var stickyLoader = bar.querySelector('[data-sticky-add-to-cart-loader]');
    var stickyPrice = bar.querySelector('[data-sticky-add-to-cart-price]');

    function currentPriceText() {
      if (!realPriceWrapper) return null;
      var isOnSale = realPriceWrapper.classList.contains('price--on-sale');
      var el = isOnSale
        ? realPriceWrapper.querySelector('[data-sale-price]')
        : realPriceWrapper.querySelector('[data-regular-price]');
      return el ? el.textContent.trim() : null;
    }

    function syncFromRealButton() {
      var disabled = realBtn.hasAttribute('disabled') || realBtn.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        stickyBtn.setAttribute('disabled', 'true');
        stickyBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.removeAttribute('aria-disabled');
      }

      var realText = form.querySelector('[data-add-to-cart-text]');
      if (realText && stickyBtnText) {
        stickyBtnText.textContent = realText.textContent.trim();
      }

      var priceText = currentPriceText();
      if (priceText && stickyPrice) {
        stickyPrice.textContent = priceText;
      }
    }

    syncFromRealButton();

    // Keep the sticky bar in sync whenever the real button/price changes
    // (e.g. when a shopper picks a different variant).
    var observer = new MutationObserver(syncFromRealButton);
    observer.observe(realBtn, { attributes: true, childList: true, subtree: true });
    if (realPriceWrapper) {
      observer.observe(realPriceWrapper, { attributes: true, childList: true, subtree: true });
    }

    // Reveal the bar once the real Add to Cart button scrolls out of view,
    // hide it again once the real button is back on screen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('sticky-add-to-cart--visible');
          } else {
            bar.classList.add('sticky-add-to-cart--visible');
          }
        });
      }, { threshold: 0 });
      io.observe(realBtn);
    }

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.hasAttribute('disabled')) return;
      if (stickyLoader) stickyLoader.classList.remove('hide');
      realBtn.click();
      setTimeout(function () {
        if (stickyLoader) stickyLoader.classList.add('hide');
      }, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
